<template>
  <el-container direction="vertical" class="app-container">
    <login-header v-if="showLoginHeader"></login-header>
    <app-header v-else></app-header>
      <router-view v-slot="{ Component }">
        <Suspense>
          <component :is="Component" />
        </Suspense>
      </router-view>
    <app-footer></app-footer>
  </el-container>
</template>

<script>
import AppFooter from '@/components/footer'
import LoginHeader from '@/components/loginHeader/LoginHeader.vue'
import AppHeader from '@/components/appHeader/AppHeader.vue'

import { computed, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getAuth } from 'firebase/auth'

export default {
  name: 'App',
  components: {
    AppFooter,
    LoginHeader,
    AppHeader
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const auth = getAuth()

    const showLoginHeader = computed(() => {
      return route.path === '/' || route.path === '/auth' || route.path === '/mudar-senha'
    })

    onBeforeMount(() => {
      auth.onAuthStateChanged((user) => {
        if (!user && (route.path === '/' || route.path === '/auth')) {
          return true
        } else if (!user && (route.path !== '/' || route.path !== '/auth')) {
          router.replace('/auth')
        } else if (route.path === '/auth' || route.path === '/') {
          router.replace('/cultura')
        }
      })
    })

    return {
      showLoginHeader
    }
  }
}
</script>

<style lang='scss'>
.app-container {
  height: 100vh;
  margin-bottom: 9rem;
}
</style>
